import { Blockquote, Inset, Link, Text } from "@radix-ui/themes";


export default function Y2025M11D14() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>
          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2025-11-14.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Photo by Valerio Lucia
              </Text>
            </Inset>
          </div>
        
          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    14-16 November 2025, Labyrinth, Zagarolo (Rome-Italy)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Workshop: <i>Pluriverse: An Ecosophic Diaspora in the Making?</i>
                  </Blockquote>
                  <Blockquote size="2" color>
                     <b>Project Ecosophy</b>
                  </Blockquote>
                  <Blockquote size="2" color>
                     Interstices Center in collaboration with FAD
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    This workshop intends to explore the interdisciplinary and transformative scope of the idea of "pluriverse" by focusing on <i>an ecosophic diaspora</i> as an ethico-political referent to transform Western models of domination into a vector of practical wisdom. If the practice of “a world of many worlds” aims at the preservation and defense of ways of living opposed to current global world-making strategies, the challenge remains to evaluate whether the accomplishment of such attempt does not require <i>an ontological shift</i> in the way knowledge is exercised and transmitted in Western culture.
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    <Link   href="https://www.shadvala.org/pdf/2025-11-14-Conception-Pluriverse-An-Ecosophic-Diaspora-in-the-Making.pdf" target="_blank">
                      Conception: Download PDF (0.15 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    <Link   href="https://www.shadvala.org/pdf/2025-11-14-Program-Pluriverse-An-Ecosophic-Diaspora-in-the-Making.pdf" target="_blank">
                      Program: Download PDF (0.15 MB) &nbsp;
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg> 
                    </Link>
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
